"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.customVariablesIndicatorsCharts")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.customVariablesIndicatorsChart", {
            url: "/customizacao",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-custom-variables-indicators-charts" */ "./custom-variables-indicators-charts.entry"
                ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.customVariablesIndicatorsCharts")
            );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "customVariablesIndicatorsChartsComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Customização"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Personalize indicadores e dashboards de acordo com as necessidades do escritório."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.customVariablesIndicatorsChart.variables", {
            url: "/contas-personalizadas",
            views: {
                "tableContent@nucont.accounting.customVariablesIndicatorsChart": {
                    component: "managerCustomVariablesComponent"
                }
            }
        })
        .state("nucont.accounting.customVariablesIndicatorsChart.indicators", {
            url: "/indicadores",
            views: {
                "tableContent@nucont.accounting.customVariablesIndicatorsChart": {
                    component: "managerCustomIndicatorsComponent"
                }
            }
        })
        .state("nucont.accounting.customVariablesIndicatorsChart.charts", {
            url: "/graficos",
            params: {
                openDialogInsert: null
            },
            views: {
                "tableContent@nucont.accounting.customVariablesIndicatorsChart": {
                    component: "managerCustomChartsComponent"
                }
            }
        });
}
